export const HOME_AREA = 'HOME_AREA';
export const AVAILABLE_BRAND_AREA = 'AVAILABLE_BRAND_AREA';
export const BRAND_AREA = 'BRAND_AREA';
export const COMPANY_AREA = 'COMPANY_AREA';
export const CHANNEL_AREA = 'CHANNEL_AREA';
export const ACCOUNT_AREA = 'ACCOUNT_AREA';
